export const PATHS = {
  ROOT: 'resumes',
  ME: 'resumes/me',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
  getOneByUserId: (id: number) => `/user/${id}/${PATHS.ROOT}`,
};
